import selectComponent from 'utilities/select-component'
import 'vendor/jquery.hoverIntent'

export default class ClassToggleNav {
    openClass = '-open'
    $document = $(document)
    $body = $('body')

    constructor(element) {
        this.$component = selectComponent(element)
        this.bindEvents()
    }

    bindEvents() {
        if (typeof this.$component.elements.toggle !== 'undefined') {
            this.$component.elements.toggle.hoverIntent(
                this.handleToggleClick
            )
        }
    }

    unbindEvents() {
        if (typeof this.$component.elements.toggle !== 'undefined') {

            //unbinds hover intent
            this.$component.elements.toggle.unbind("mouseenter").unbind("mouseleave");
            this.$component.elements.toggle.removeProp('hoverIntent_t');
            this.$component.elements.toggle.removeProp('hoverIntent_s');
        }
    }

    handleToggleClick = event => {
        if (!this.$component.hasClass(this.openClass)) {
            this.$component.addClass(this.openClass)
            setTimeout(() => {
                this.$body.addClass('-nav-open')
            }, 10)
            return
        }

        this.$body.removeClass('-nav-open')
        this.$component.removeClass(this.openClass)
    }

    handleDocumentClick = event => {
        if (
            typeof this.$component.elements.togglecart !== 'undefined' &&
            event.target != this.$component.elements.togglecart[0] &&
            !$.contains(this.$component.elements.togglecart[0], event.target) && 
            !this.$component.elements.nav.find(event.target).length
        ) {
            this.$component.removeClass(this.openClass)
            this.$body.removeClass('-nav-open')
        }
    }
}
